import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'product-download-dialog',
  templateUrl: './product-download-dialog.component.html',
  styleUrls: ['./product-download-dialog.component.less']
})
export class ProductDownloadDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProductDownloadDialogDialogData,
    private dialogRef: MatDialogRef<ProductDownloadDialogComponent>
  ) {}

  onClickDownload() {
    FileSaver.saveAs(this.data.url, this.data.fileName);
    this.dialogRef.close();
  }
}

export interface ProductDownloadDialogDialogData {
  url: string;
  fileName: string;
}
